import '../common/popup';
if (/^\/english\//.test(window.location.pathname)) {
  window.lang = 'en';
} else {
  window.lang = 'ja';
}

// ムーズスクロールの設定
document.querySelectorAll("a[href^='#']").forEach(function(accordion) {
  accordion.addEventListener('click', {
    handleEvent: function(event) {
      event.preventDefault();
      document.querySelector(event.target.hash).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
  });
});

// To Top ボタン
window.onscroll = function () {
  let linkPagetop = document.getElementById('linkPagetop');
  if(linkPagetop){
    if (pageYOffset >= 50) {
      linkPagetop.style.visibility = "visible";
    } else {
      linkPagetop.style.visibility = "hidden";
    }
  }
};
window.scroll(0,0);

// 詳細ページの画像縮小
document.querySelectorAll('img.pict').forEach(function(img) {
  let w = img.naturalWidth;
  let h = img.naturalHeight;
  if( w > h ){
    img.style.width = '206px';
    img.style.height = 'auto';
  }
  else{
    img.style.width = 'auto';
    img.style.height = '155px';
  }
});
